import React from 'react';

import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-metrics';

import { useStateMachineContext } from '@common/context/StateMachineContext';

import { TENANT_CONFIG, LANDLORD_CONFIG, TENANT_ROLE } from '../../constants';

import ContactUsHeader from '../ContactUsHeader';

import './ContactCategories.scss';

const getCategoriesFromRole = role => {
  const categories = role === TENANT_ROLE ? TENANT_CONFIG : LANDLORD_CONFIG;

  return Object.keys(categories);
};

const ContactCategories = () => {
  const { payload, send } = useStateMachineContext();

  const baseLocoKey = `contact-us.${payload.role}`;

  const handleCategoryClicked = categoryId => {
    Metrics.ga.sendEvent(
      'contact_form_revamp',
      'category_clicked',
      `${categoryId}`
    );
    send('SELECT', { categoryId });
  };

  return (
    <div className="contact-us-form__fields">
      <ContactUsHeader title={trans(baseLocoKey)} onBack={() => send('BACK')} />
      {getCategoriesFromRole(payload.role).map(category => (
        <Button
          key={category}
          color="primary"
          size="large"
          fullWidth
          onClick={() => handleCategoryClicked(category)}
          className="contact-us-form__button"
        >
          {trans(`${baseLocoKey}.${category}`)}
        </Button>
      ))}
    </div>
  );
};

export default ContactCategories;
